import React from 'react';
import { connect } from 'react-redux';
import { stubTrue, noop } from 'lodash';
import PropTypes from 'prop-types';
import { AccountDropdown } from 'modules/campaigns/modules/common-campaign-form/components/AccountDropdown/AccountDropdown';
import { COMPONENT_STATUS } from 'services/constants';
import { resetAccounts, retryFetchAccounts } from '../../../actions';
import { fetchAccounts } from '../../../flows';
import { accountsSelector } from '../../../selectors';

const CustomAccountDropdown = ({
    onAccountChange,
    accountForCampaign,
    helpText,
    accounts,
    accountsTotal,
    fetchMoreAccountsFlow,
    resetAccountsAction,
    retryFetchAccountsAction,
    status,
    pageSize,
    accountFilter,
    noAccountsMessageId,
    className,
    disabled = false,
}) => {
    return (
        <AccountDropdown
            onAccountChange={onAccountChange}
            accountForCampaign={accountForCampaign}
            helpText={helpText}
            accounts={accounts}
            accountsTotal={accountsTotal}
            fetchMoreAccountsFlow={fetchMoreAccountsFlow}
            resetAccountsAction={resetAccountsAction}
            retryFetchAccountsAction={retryFetchAccountsAction}
            status={status}
            pageSize={pageSize}
            accountFilter={accountFilter}
            noAccountsMessageId={noAccountsMessageId}
            className={className}
            disabled={disabled}
            skipFormResetOnAccountChange={true}
            skipAppAccountCheck={true}
        />
    );
};

CustomAccountDropdown.propTypes = {
    onAccountChange: PropTypes.func.isRequired,
    accountForCampaign: PropTypes.object,
    helpText: PropTypes.node,
    accounts: PropTypes.array,
    accountsTotal: PropTypes.number,
    fetchMoreAccountsFlow: PropTypes.func.isRequired,
    resetAccountsAction: PropTypes.func.isRequired,
    status: PropTypes.oneOf(Object.values(COMPONENT_STATUS)),
    retryFetchAccountsAction: PropTypes.func.isRequired,
    pageSize: PropTypes.number,
    dropdownStyles: PropTypes.object,
    accountFilter: PropTypes.func,
    noAccountsMessageId: PropTypes.string,
    className: PropTypes.string,
};

CustomAccountDropdown.defaultProps = {
    accounts: [],
    accountForCampaign: {},
    helpText: null,
    pageSize: 10,
    accountFilter: stubTrue,
    noAccountsMessageId: 'app.account.noResults',
    onAccountChange: noop,
};

const mapStateToProps = state => {
    const { accountsTotal, fetchAccountsStatus: status } = state.appReducer;
    const accounts = accountsSelector(state);

    return {
        accounts,
        accountsTotal,
        status,
    };
};

const mapDispatchToProps = {
    fetchMoreAccountsFlow: fetchAccounts,
    resetAccountsAction: resetAccounts,
    retryFetchAccountsAction: retryFetchAccounts,
};

export { CustomAccountDropdown };
export const ConnectedCustomAccountDropdown = connect(mapStateToProps, mapDispatchToProps)(CustomAccountDropdown);
